import {
    CHAT_ROUTE,
    DIRECT_CHATS_ROUTE,
    REQUEST_CHAT_ROUTE,
    MESSAGE_ROUTE
} from "../consts";

export const getMessagesUnreadCount = ({messages} = {}) => {
    return Number(messages?.totalUnreadCount || 0);
};

export const getMessagesTargetRoute = () => {
    return MESSAGE_ROUTE;
};

export const isMessagesRoute = (pathname = "") => {
    return (
        pathname.startsWith(MESSAGE_ROUTE) ||
        pathname.startsWith(CHAT_ROUTE) ||
        pathname.startsWith(DIRECT_CHATS_ROUTE) ||
        pathname.startsWith(REQUEST_CHAT_ROUTE)
    );
};

export const formatMessagesBadge = (count) => {
    const value = Number(count || 0);

    if (value > 99) return "99+";

    return value;
};